function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useThrottle } from "../../hooks/useThrottle";
import { NodesUtil } from "../NodesUtil";
import { useSignal } from "@preact/signals-react";
import isBlank from "@sedan-utils/is-blank";
import { Input } from "antd";
import classNames from "classnames";
import React, { useCallback, useEffect, useRef } from "react";
import style from "./TextNode.module.scss";
import { TextNodeBloc } from "./TextNodeBloc";
import { TextLoading } from "../components/TextLoading/TextLoading";
import { ViewBuilderWorker } from "../ViewBuilderComponents/ViewBuilderWorker";
import { ViewBuilder } from "../ViewBuilderComponents/ViewBuilder";
// import { GetItContext } from "@base/provider/GetItContext";
// import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
// import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";

// import { StudioProjectAttributesV3NodeData } from "imagica-corekit/dist/base/project/domain/StudioProjectAttributesV3NodeData";
import cls from "classnames";
export var Text = function Text(props) {
  var _props$checkNodeArr, _props$checkNodeArr$i, _props$textAreaValue2;
  // const enableBlurType = ["text", "inputTextarea"];
  // const isChildNode = props.parentNodeId !== "";
  var isScrollBottom = useSignal(false);
  var showTopShadow = useSignal(false);
  var showBottomShadow = useSignal(false);
  var inputBoxRef = useRef(null);
  var scrollZoneRef = useRef(null);
  var bloc = new TextNodeBloc(props);
  // const enableViewBuilder = useContext(GetItContext)(HomeStore).state.featureTags.enableViewBuilder;
  var showBuilderUI = ViewBuilderWorker.isShowBuilderUI(!!props.showBuilderUI);
  useThrottle(function () {
    if (bloc.textValue.value.length > 260 && scrollZoneRef.current && props.showStopGenerateBtn === true) {
      // 滚动到底部
      var distance = scrollZoneRef.current.scrollHeight - scrollZoneRef.current.clientHeight;
      scrollZoneRef.current.scrollTop = distance;
    }
  }, 100, [bloc.textValue.value, props.showStopGenerateBtn]);
  useEffect(function () {
    if (props.showStopGenerateBtn === false) {
      setTimeout(function () {
        // 滚动到顶部
        if (scrollZoneRef.current) {
          scrollZoneRef.current.scrollTop = 0;
        }
      }, 200);
    }
  }, [props.showStopGenerateBtn]);
  var handleNodeScroll = function handleNodeScroll() {
    var nodeRef = scrollZoneRef.current;
    if (nodeRef) {
      var contentScrollTop = nodeRef.scrollTop; // 滚动条距离顶部
      var clientHeight = nodeRef.clientHeight; // 可视区域
      var scrollHeight = nodeRef.scrollHeight; // 滚动条内容的总高度
      if (contentScrollTop + clientHeight >= scrollHeight) {
        isScrollBottom.value = true;
      } else {
        // 需要保留，滚动条向上回滚时才会生效
        isScrollBottom.value = false;
      }
    }
  };
  var textNodeClassName = classNames(style["custom-node"], style["design-text"], (props.isLongPress || ((_props$checkNodeArr = props.checkNodeArr) === null || _props$checkNodeArr === void 0 || (_props$checkNodeArr$i = _props$checkNodeArr.includes) === null || _props$checkNodeArr$i === void 0 ? void 0 : _props$checkNodeArr$i.call(_props$checkNodeArr, props.id))) && "nopan ".concat(NodesUtil.constants.NO_WHEEL), style["guide-textnode-disable"], props.enableFeedback && style["target"], !props.disableAddPreview && props.isStartNode && !props.isStartNodeAdded && !(props !== null && props !== void 0 && props.isStaticApp) ? style.reservedButtonHeight : "");
  function handleScroll() {
    var current = scrollZoneRef.current;
    if (current) {
      showTopShadow.value = current.scrollTop > 1;
      showBottomShadow.value = current.scrollHeight - current.scrollTop > current.clientHeight + 1;
    }
  }
  var changeText = function changeText(e) {
    props.setTextAreaValueWithParam({
      content: e.target.value
    });
    // 编辑后重置view builder数据
    props.setNodes(function (nodes) {
      return nodes.map(function (node) {
        if (node.id === props.id) {
          var _props$textAreaValue;
          return _objectSpread(_objectSpread({}, node), {}, {
            data: _objectSpread(_objectSpread({}, node.data), {}, {
              viewBuilderData: {
                loadingHtml: false,
                isRequestStart: false,
                domList: [],
                originalText: (_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue.results) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.content
              }
            })
          });
        }
        return node;
      });
    });
  };
  var changeShowBuilderUI = useCallback(function (bool) {
    props === null || props === void 0 || props.onChangeData({
      showBuilderUI: bool
    });
  }, [props === null || props === void 0 ? void 0 : props.onChangeData]);
  useEffect(function () {
    if (scrollZoneRef.current) {
      scrollZoneRef.current.addEventListener("scroll", handleScroll);
    }
    return function () {
      if (scrollZoneRef.current) {
        scrollZoneRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [scrollZoneRef]);

  // 在blueprint中高度由内容决定
  // STUD-1371 改为高度由内容决定
  // const reSizeStyle = bloc.isInBlueprint.value ? {} : bloc.reSizeStyle();

  if (props.textLoading) return /*#__PURE__*/React.createElement(TextLoading, null);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style.textNodeScrollZone, props.className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, style.colorMode1, !props.readOnly), style.readOnlyText, props.readOnly), style.topShadow, showTopShadow.value), style.bottomShadow, showBottomShadow.value)),
    "data-testid": "TextNode",
    style: props.readOnly ? props.readonlyStyle : undefined
  }, !showBuilderUI && /*#__PURE__*/React.createElement("div", {
    ref: scrollZoneRef,
    className: style.textNodeScroll
  }, /*#__PURE__*/React.createElement("div", {
    className: textNodeClassName,
    ref: inputBoxRef,
    onScroll: props.readOnly ? undefined : handleNodeScroll
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(style["text-content"], props.isInCanvas ? style["textDefaultPadding"] : style["textResetPadding"])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style["input-mask"], _defineProperty(_defineProperty(_defineProperty({}, style["hidden-mask"], props.isLongPress), style["previewing"], !props.disableAddPreview), style["input-in-blueprint"], bloc.isInBlueprint.value))
  }, !props.isLongPress && (isBlank(bloc.textValue.value) || typeof bloc.textValue.value === "string") ? /*#__PURE__*/React.createElement("p", {
    "data-testid": "TextNode-value",
    className: classNames(style["alternate-text"], _defineProperty({}, style["place-color"], isBlank(bloc.textValue.value)))
  }, typeof bloc.textValue.value === "string" && bloc.textValue.value || bloc.placeHolder.value) : null), !props.readOnly && !bloc.isInBlueprint.value && /*#__PURE__*/React.createElement("div", {
    className: classNames(style["text-textArea"], _defineProperty(_defineProperty(_defineProperty({
      nodrag: props.isLongPress
    }, style["show-text-textArea"], props.isLongPress), style["max-textarea-height"], !props.isResized), style["addBottom"], props.isTargetNode))
  }, /*#__PURE__*/React.createElement(Input.TextArea, {
    className: classNames(style.textarea, {
      "hidden-input": !props.isLongPress
    }),
    value: (_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 || (_props$textAreaValue2 = _props$textAreaValue2[0]) === null || _props$textAreaValue2 === void 0 || (_props$textAreaValue2 = _props$textAreaValue2.results) === null || _props$textAreaValue2 === void 0 || (_props$textAreaValue2 = _props$textAreaValue2[0]) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2.content,
    ref: props.inputRef,
    onPressEnter: props.onTextAreaEnter,
    onChange: changeText,
    onBlur: function onBlur(e) {
      return props.onTextAreaBlur(e);
    },
    onFocus: props.onTextAreaFocus,
    placeholder: bloc.placeHolder.value
    // autoSize={{ minRows: 4 }}
    ,
    autoSize: true,
    style: {
      minHeight: "54px"
    }
  }))))), props.enableViewBuilder && /*#__PURE__*/React.createElement("div", {
    className: style.viewBuilder
  }, /*#__PURE__*/React.createElement(ViewBuilder, _extends({}, props, {
    changeShowBuilderUI: changeShowBuilderUI
  }))));
};